var backToTop = {};

const $backToTop = $('.js-back-to-top');

function toTop (scrollTop) {
	scrollTop = $(window).scrollTop();
	if (scrollTop > 400) {
		$backToTop.addClass('show');
	} else if (scrollTop < 400) {
		$backToTop.removeClass('show');
	}
}

backToTop.init = function () {

	toTop();
	var lastScrollTop = 0;
	var scheduledAnimationFrame;
	function functiePreScrollEvent() {
		toTop();
		scheduledAnimationFrame = false;
	}
	function onScroll (evt) {
		if (scheduledAnimationFrame){
			return;
		}
		scheduledAnimationFrame = true;
		requestAnimationFrame(functiePreScrollEvent);
	}
	window.addEventListener('scroll', onScroll);

	$backToTop.click(function() {
		window.scrollTo({top: 0, behavior: 'smooth'});
	});

};

export { backToTop };
